<!-- eslint-disable -->
<template lang="pug">
    .dropdown-container(v-on-clickaway="close")
        a.dropdown-link(:class="{'is-active': active, 'dropdown-link--header': header}" href="javascript://" @click="toggle")
            slot(name="link")
            svg-icon.icon(name="angle" size="small" v-if="icon" :class="{'icon--reverse': this.active}")
            slot(name="after-icon")
        .dropdown(:class="{'is-open': active, 'is-last': isLast, 'dropdown_without-move': withoutMove }")
            slot
</template>

<script>
    /*eslint-disable*/
    import {mixin as clickaway} from 'vue-clickaway'

    export default {
        props: {
            icon: {
                type: Boolean,
                default: true
            },
            header: {
                type: Boolean,
                default: false
            },
            withoutMove: {
                type: Boolean,
                default: false
            },
            isLast: {
                type: Boolean,
                default: false
            }
        },
        mixins: [clickaway],
        data () {
            return {
                active: false
            }
        },
        watch: {
            '$route' (val) {
                this.active = false
            }
        },
        methods: {
            toggle () {
                this.active = !this.active
            },
            close () {
                this.active = false
            }
        }
    }
</script>

<style lang="scss">
    .dropdown-container {
        position: relative;
        word-break: initial;
    }

    .dropdown {
        display: none;
        right: 15px;
        box-sizing: border-box;
        position: absolute;
        top: calc(100% + 6px);
        z-index: 1000;
        padding: 6px;
        min-width: 170px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.35);
        border-radius: 5px;
        background-color: $x-color-white;

        &.is-open {
            display: block;
        }

        &.is-last {
            bottom: calc(100% + 6px);
            top: auto;

            &::after {
                bottom: 0;
                top: auto;
                transform-origin: 100% 100%;
                transform: rotate(315deg);
            }
        }

        &::after {
            content: "";
            position: absolute;
            width: 0.5em;
            height: 0.5em;
            right: 1em;
            top: 0;
            box-sizing: border-box;
            transform-origin: 0 0;
            transform: rotate(135deg);

            background-color: $x-color-white;
            background: linear-gradient(to top right, $x-color-white 0, $x-color-white 50%, transparent 0, transparent);
        }
    }

    .dropdown_without-move {
        right: -6px;
        top: calc(100% - 9px);
        @include media($lg) {
            right: -10px;
            top: calc(100% - 15px);
        }
    }

    .dropdown-link--header {
        width: fit-content;
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: $x-color-white;

        .icon {
            color: $x-color-white;
            margin-left: 9px;
        }

        .icon--reverse {
            transform: rotate(0.5turn);
        }

        &:hover {
            color: $hsl-color-gray-74;
            .icon {
                color: $hsl-color-gray-74;
            }
        }
    }
</style>
